import { track } from './core';

export function trackMainSigninClicked() {
  track('main_signin_clicked');
}

export function trackAuthSigninSubmitted() {
  track('auth_signin_submitted');
}

export function trackAuthSigninCompleted(email) {
  track('auth_signin_completed', { email });
}

export function trackAuthSigninFailed(error) {
  track('auth_signin_failed', { error });
}

export function trackAuthGoogleSigninClicked() {
  track('auth_google_signin_clicked');
}

export function trackAuthForgotPasswordClicked() {
  track('auth_forgot_password_clicked');
}

export function trackAuthRememberMeToggled(enabled) {
  track('auth_remember_me_toggled', { enabled });
}

export function trackAuthCreateAccountClicked() {
  track('auth_create_account_clicked');
}

export function trackAuthSsoCompleted(method) {
  track('auth_sso_signin_completed', { method });
}

export function trackAuthSsoFailed(method, error) {
  track('auth_sso_signin_failed', { method, error });
}
